import React from "react";
import { connect } from "react-redux";
import { Modal } from "semantic-ui-react";
import { closeModal, openModal } from "../../redux/Modals/ModalActions";
import { showToast } from "../../redux/Snackbar/SnackbarActions";
import useTheme from "../../hooks/useTheme";
import { AppColumn, AppRow } from "./Layouts";
import { useResponsive } from "./ResponsiveContext";
import { SizedBox } from "./Sizes";
import AppPrimaryTextfield from "./TextInput";
import AppText from "./Texts/AppTexts";

import axios from "axios";
import { useState } from "react";
import { QUERY_WORKPLACES } from "../../utils/Controller/URLConstants";
import { AppLinkedText, CloseCircleButton } from "./CustomButtons";
import CircularLoader from "./LoadingIndicators/CircularLoadingIndicators";
import AppWorkplaceCard from "./Cards/WorkplaceCard";

const actions = {
    openModal,
    closeModal,
    showToast,
};

const FindYourWorkplacePage = ({ closeModal, openModal, onWorkplaceSelected }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();

    const [query, setQuery] = useState("");
    const [isFetching, setIsFetching] = useState(false);

    const [searchedWorkplaces, setSearchedWorkplaces] = useState([]);
    const [selectedWorkplace, setSelectedWorkplace] = useState(null);


    const handleSearch = (searchTerm) => {


        if (searchTerm.length < 3) {
            setSearchedWorkplaces([]);
            return;
        }

        let timer;

        clearTimeout(timer);
        timer = setTimeout(async () => {

            const workplaces = await getQueryWorkPlaces(searchTerm);

            setSearchedWorkplaces(workplaces);
            setIsFetching(false);

        }, 800);
    }


    async function getQueryWorkPlaces(query) {
        try {

            if (isFetching === false) {
                setIsFetching(true);

                const response = await axios.get(QUERY_WORKPLACES + `?query=${encodeURIComponent(query)}`);
                if (response.data && response.data.status === 0) {
                    const workplaces = response.data.results;


                    return workplaces;
                }
            }


        } catch (error) {
            console.error("Error fetching workplaces:", error);
        }

        setIsFetching(false);

        return searchedWorkplaces;
    }




    return (<Modal
        centered={true}
        open={true}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={() => {
            closeModal();
        }}
        basic
        style={{
            margin: "0",
            padding: "0",
            top: "0",
            borderRadius: isMobile ? "0px" : theme.radius.default,
            height: isMobile ? "100%" : "80vh",
            width: isMobile ? "100%" : "54%",
            marginTop: isMobile ? "0px" : theme.spacing.cardPadding,
            marginBottom: isMobile ? "0px" : theme.spacing.cardPaddingBig,
            backgroundColor: theme.colors.white,
            overflow: "hidden",
            transform: "none",
        }}
    >
        <AppColumn style={{
            flex: 1,
            padding: theme.spacing.contentPadding,
            borderRadius: theme.radius.small,
        }}>
            <AppRow mainAxisAlignment={"space-between"} crossAxisAlignment="center">
                <AppText.BodyText fontWeight={600} color={theme.primaryColor}>
                    {"Find your workplace"}
                </AppText.BodyText>
                <CloseCircleButton
                    onClick={() => {
                        closeModal();
                    }}
                />
            </AppRow>
            <SizedBox height={theme.spacing.elementPadding} />
            <AppPrimaryTextfield
                value={query}
                capitalizedText="word"
                onChange={(value) => {
                    setQuery(value);
                    handleSearch(value);
                }}
                suffixIcon={isFetching && (<div style={{
                    padding: '0.5rem',
                }}>
                    <CircularLoader />
                </div>)}
                hintText={"Search for your workplace"}
                prefixIcon={"search"}
            />

            <div style={{
                overflowY: "auto",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                scrollBehavior: "smooth",
                width: '100%',
                position: "relative"
            }}>
                <SizedBox height={theme.spacing.contentPadding} />
                <div style={{
                    height: isMobile ? '420vw' : '120vw',
                }}>

                    {searchedWorkplaces.map((workplaceData, index) => (
                        <AppWorkplaceCard workplaceData={workplaceData} type='search' onClick={() => {
                            setSelectedWorkplace(workplaceData);

                            if (onWorkplaceSelected) {
                                onWorkplaceSelected(workplaceData);
                                closeModal();
                            }
                        }} />
                    ))}
                </div>


            </div>

            <SizedBox height={theme.spacing.elementPadding} />
            {searchedWorkplaces.length <= 0 && <AppRow>
                <AppText.Caption>
                    {"Can't find your workplace?"}
                </AppText.Caption>
                <SizedBox width={theme.spacing.elementPadding} />
                <AppLinkedText
                    text={"Add manually"}
                    color={theme.primaryColor}
                    onClick={() => {
                    }}
                    underline
                />
            </AppRow>}

        </AppColumn>

    </Modal>)
}


export default connect(null, actions)(FindYourWorkplacePage);

export const MODAL_FIND_YOUR_WORKPLACE = "FindYourWorkplacePage";